import { ref } from '@nuxtjs/composition-api';
import { useStoryblok } from './useStoryblok';

export function useFetchPaginatedArticles() {
  const { storyblok } = useStoryblok();
  const newArticles = ref([]);
  const canFetchMore = ref(false);

  async function getPaginatedArticles(options) {
    const res = await storyblok.getPaginatedArticles({ ...options });

    canFetchMore.value = res.canFetchMore;
    newArticles.value = res.data;
  }

  return {
    getPaginatedArticles,
    canFetchMore,
    newArticles,
  };
}
